import React, { useContext } from 'react'
import { apiPut } from '../../../utils/apiFetch'
import apiPath from '../../../utils/apiPath'
import { isEmpty } from 'lodash'
import { AiFillDelete, AiFillEye } from 'react-icons/ai'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import useToastContext from 'hooks/useToastContext'
import helper from '../../../utils/helpers'
import { BsArrowUpShort } from 'react-icons/bs'
import { Link } from 'react-router-dom'

const Table = ({
  posts,
  getAllPosts,
  page,
  sort,
  setSort,
  manager,
  userDetails
}) => {
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const notification = useToastContext()
  
  const handelStatusChange = async item => {
    try {
      const payload = {
        status: item?.status === 'inactive' ? 'active' : 'inactive'
      }
      const path = `${apiPath.postChangeStatus}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        getAllPosts()
      }
    } catch (error) {
      console.log('error in get all faqs list==>>>>', error.message)
    }
  }

  const handelDelete = async (item) => {
    try {
      const path = apiPath.deletePost + "/" + item?._id;
      const result = await apiPut(path);
      if (result?.status === 200) {
        notification.success(result.data.message);
        getAllPosts()
      } else {
        notification.error(result.data.message);
      }
    } catch (error) {
      console.log("error in get all FAQs list==>>>>", error.message);
    }
  };

  return (
    <div className='p-3'>
      <div className='overflow-x-auto relative rounded-lg border'>
        <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
          <thead className='text-xs text-gray-900 border border-[#E1E6EE]  bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
            <tr>
              <th scope='col' className='py-3 px-6'>
                #
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('O_DESCRIPTION')}
              </th>
              <th
                scope='col'
                className='py-3 px-1 cursor-pointer'
                onClick={() => {
                  if (
                    sort.sort_key === 'createdAt' &&
                    sort.sort_type === 'asc'
                  ) {
                    setSort({
                      sort_key: 'createdAt',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'createdAt',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex justify-end'>
                  <span>{t('O_CREATED_AT')}</span>
                  <span>
                    {sort.sort_key === 'createdAt' &&
                      sort.sort_type === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                    {sort.sort_key === 'createdAt' &&
                      sort.sort_type === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                  </span>
                </div>
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('O_POST_STATUS')}
              </th>
              {(manager?.add || user?.role === 'admin') && (
                <>
                  <th scope='col' className='py-3 px-6 text-center'>
                    {t('O_STATUS')}
                  </th>
                  <th scope='col' className='py-3 px-6 text-center'>
                    {t('O_ACTION')}
                  </th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {posts &&
                posts?.map((item, i) => (
                <tr
                  key={i}
                  className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                >
                  <th
                    scope='row'
                    className='py-4 px-6 border-r font-medium text-gray-900  dark:text-white'
                  >
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className='py-4 px-6 border-r'>{item?.description}</td>
                  <td className='py-4 px-6 border-r text-right'>
                    {helper.dateFormat(item?.createdAt)}
                  </td>
                  <td className='py-4 px-6 border-r text-right'>
                    {item?.isDeleted ? 'Deleted' : item?.status === 'active' ? "Active" : "Inactive"}
                  </td>
                  {(manager?.add || user?.role === 'admin') && (
                    <td className='py-4 px-6 border-r text-center'>
                      <label
                        className='inline-flex relative items-center cursor-pointer'
                        title={`${
                          item?.status === 'active' ? 'Active' : 'Inactive'
                        }`}
                      >
                        <input
                          type='checkbox'
                          className='sr-only peer'
                          disabled={item?.isDeleted}
                          checked={item?.status === 'active'}
                          onChange={e =>
                            helper.alertFunction(
                              `${t('ARE_YOU_SURE')} ${
                                e.target.checked ? t('O_ACTIVE_SMALL') : t('O_INACTIVE_SMALL')
                              } this post ?`,
                              item,
                              handelStatusChange
                            )
                          }
                          // onChange={(e) => handelStatusChange(item)(e)}
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                      </label>
                    </td>
                  )}
                        {(manager?.add ||
                    user?.role==='admin') && (
                  <td className='py-4 px-6 border-l'>
                    <div className=''>
                      <ul className='flex justify-center'>
                        <Link
                          title={t("O_VIEW")}
                          className="text-danger ml-2"
                          to="/users/post/view"
                          state={{ item, userDetails }}
                        >
                          <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />
                        </Link>
                        {(manager?.delete || user?.role === "admin") && !item?.isDeleted && (
                          <li
                            onClick={(e) =>
                              helper.alertFunction(
                                `${t('ARE_YOU_SURE_TO_DELETE_POST')}`,
                                item,
                                handelDelete,
                                true
                              )
                            }
                            // onClick={() => handelDelete(item)}
                            className="px-2 hover:bg-white hover:text-LightBlue"
                          >
                            <a title={t("O_DELETE")}>
                              {" "}
                              <AiFillDelete className="w-5 h-5 text-red-600" />{" "}
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                  </td>
                    )}
                </tr>
              ))}
            {isEmpty(posts) ? (
              <tr className='bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700'>
                <td className='py-4 px-6 border-r' colSpan={9}>
                  {t('O_NO_RECORD_FOUND')}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Table